import * as Mui from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from "react-hook-form";
import { DamageFormTypes } from "../../Types";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import { ContextOperation } from "../../../../context/OperationContext";
import DamageFormService from "../../service/DamageFormService";
import useSnackbar from "../../../../hooks/useSnackbar";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    updateActions: () => void;
}
const NewAction = (props: Props) => {

    const {tenant} = useContext(ContextOperation);

    const t = useOperationTranslation();

    const {id} = useParams (); 
    const snackBar = useSnackbar();

    const form = useForm<DamageFormTypes.IAddAction>({
        defaultValues: {
            damageFormId: parseInt(id || "0")
        }
    });

    const onSubmit = (data: DamageFormTypes.IAddAction) => {
        DamageFormService.details.actions.post.addaction(
            tenant, data
        ).then(
            (response) => {
                snackBar.show("success", t("damageForm.details.action.newAction.snackbar.success"));
                props.onClose();
                form.reset({
                    damageFormId: data.damageFormId,
                    message: "",
                })
                props.updateActions()
            },
            (error) => {
                snackBar.show("error", t("damageForm.details.action.newAction.snackbar.error"));
            }
        )
    }

    return(
            <Mui.Dialog
                open={props.open}
                onClose={props.onClose}
                fullWidth
                maxWidth="lg"
            >
                <Mui.DialogTitle>
                    <Mui.Grid container alignItems="center">
                        <Mui.Grid item>
                            <Mui.Typography variant="h5">
                                {t("damageForm.details.action.newAction.title")}
                            </Mui.Typography>
                        </Mui.Grid>
                        <Mui.Grid item marginLeft={"auto"} >
                            <Mui.IconButton onClick={props.onClose}>
                                <CloseIcon />
                            </Mui.IconButton>
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.DialogTitle>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Mui.DialogContent>
                        <Mui.Grid container spacing={1}>
                            <Mui.Grid item container xs={12} alignItems="center">
                                <Mui.Grid item md={1} xs={12}>
                                    {t("damageForm.details.action.newAction.action")}
                                </Mui.Grid>
                                <Mui.Grid item md={11} xs={12}>
                                    <Mui.TextField 
                                        variant="outlined"
                                        rows={5}
                                        multiline
                                        fullWidth
                                        value={form.watch("message")}
                                        onChange={(event) => {
                                            form.setValue("message", event.currentTarget.value)
                                        }}
                                    />
                                </Mui.Grid>
                            </Mui.Grid>
                        </Mui.Grid>
                    </Mui.DialogContent>

                    <Mui.DialogActions>
                        <Mui.Grid container spacing={2}>
                            <Mui.Grid item xs="auto" ml="auto">
                                <Mui.Button variant="outlined" onClick={props.onClose} size="smallPlus">
                                    <Mui.Typography color="inherit" variant="h6">
                                        {t("damageForm.details.action.newAction.button.cancel")}
                                    </Mui.Typography>
                                </Mui.Button>
                            </Mui.Grid>

                            <Mui.Grid item xs="auto">
                                <Mui.Button type="submit" size="smallPlus" >
                                    <Mui.Typography color="inherit" variant="h6">
                                        {t("damageForm.details.action.newAction.button.saveAction")}
                                    </Mui.Typography>
                                </Mui.Button>
                            </Mui.Grid>
                        </Mui.Grid>
                    </Mui.DialogActions>
                </form>
            </Mui.Dialog>
    )
}
export default NewAction;